/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_EmptyInputs */

const cs_reports_empty = /** @type {(inputs: Reports_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádná data reportů.`)
};

const en_reports_empty = /** @type {(inputs: Reports_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No report data.`)
};

/**
* | output |
* | --- |
* | "No report data." |
*
* @param {Reports_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_empty = /** @type {((inputs?: Reports_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_empty(inputs)
	return cs_reports_empty(inputs)
});